import React from 'react';
import {useOktaAuth } from '@okta/okta-react';
import { Navigate, Outlet } from 'react-router-dom';
import { toRelativeUrl } from '@okta/okta-auth-js';


export const RequiredAuth: React.FC = () => {
    const { oktaAuth, authState } = useOktaAuth();

    if ((!authState || !authState?.isAuthenticated) && authState !== null) {
        const originalUri = toRelativeUrl(window.location.href, window.location.origin);
        oktaAuth.setOriginalUri(originalUri);
        return <Navigate to="/login" />;
    }

    return <Outlet />;
};
